import { render } from "./DurationDropdown.vue?vue&type=template&id=dcd04f46"
import script from "./DurationDropdown.vue?vue&type=script&lang=js"
export * from "./DurationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__